module.exports = __webpack_public_path__ + "static/media/Vector.72dc3e1d.svg";